import React from "react";
import useHandleBoxTypes from "../../hooks/useHandleBoxTypes";
import useHover from "../../hooks/useHover";
import MainStore from "../../stores/MainStore";

const SmallObjectListHolder = ({ object, onObjectClicked, width }) => {
  const hover = useHover();
  const { player } = MainStore();
  const { getBoxType } = useHandleBoxTypes();
  const boxType = getBoxType(object?.type);
  return (
    <div
      {...hover.divProps}
      onClick={() => {
        if (onObjectClicked) onObjectClicked(object);
      }}
      className="divRow"
      style={{
        cursor: "pointer",
        width,
        border: "3px solid grey",
        padding: "2px",
        borderRadius: ".4rem/.4rem",
        backgroundColor: boxType.colors.primary,
      }}
    >
      <div
        className="textBoldWhite"
        style={{
          color: hover.hover ? "white" : boxType.colors.text,
          fontSize: "14px",
        }}
      >
        {object.shortDescription}
      </div>
    </div>
  );
};

export default SmallObjectListHolder;
